<template>
  <div class="w-full">
    <partner-header-component v-if="route.params.partner_name" />
    <header-analistas-component v-else-if="route.name === 'Analistas XP'" />
    <header-ranking v-else @activeDetails="activeDetails" :categories="list_category" />
    <div class="dark:bg-ontick-carbon-500 sticky top-0 z-20 flex w-full flex-col bg-gray-50 px-3 md:px-6">
      <div class="dark:border-ontick-steel-500 border-b-2 border-gray-300 py-6">
        <menu-top-marketplace
          :table="getListMode"
          :showRanking="showRanking"
          @order="active_filter = !active_filter"
          @favorite="active_favorite = !active_favorite"
          @partner-strategy-search="partnerSearch"
        />
      </div>
      <filter-indicators-component v-if="getActiveFilters.length" />
    </div>

    <div
      :class="getListMode ? 'grid-cols-1 gap-3' : 'grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'"
      class="relative grid px-3 py-6 transition-all duration-100 ease-in-out md:px-6"
    >
      <template v-if="products.length > 0">
        <template v-if="route.params.partner_name">
          <div v-for="(product, $index) in filtered_results" :key="$index" name="company" is="transition-group">
            <card-marketplace
              v-for="strategy in product.strategies"
              :key="strategy.strategy_id"
              :class="details_index == $index ? 'relative z-50 ' : 'z-10'"
              :product="product"
              :strategy="strategy"
              :favorite="favorite.includes(strategy.strategy_id)"
              :visualization="getListMode"
              :partnerInfo="getPartnerInfo"
              @close="active_filter = false"
              @click.native="activeDetails(strategy, product, $index)"
            />
          </div>
        </template>
        <template v-else>
          <div v-for="(product, $index) in products" :key="$index" name="company" is="transition-group">
            <card-marketplace
              v-for="strategy in product.strategies"
              :key="strategy.strategy_id"
              :class="details_index == $index ? 'relative z-50 ' : 'z-10'"
              :product="product"
              :strategy="strategy"
              :favorite="favorite.includes(strategy.strategy_id)"
              :visualization="getListMode"
              @close="active_filter = false"
              @click.native="activeDetails(strategy, product, $index)"
              @upgrade-needed="openUpgradeModal"
            />
          </div>
        </template>
      </template>
      <infinite-loading
        v-if="query == '' && !route.params.partner_name && !getActiveFilters.length"
        @infinite="loadedProduct"
      >
        <div slot="spinner">
          <div class="hidden w-full pr-2" name="company" is="transition-group">
            <Placeholder v-show="limit_page + 1 != page" :qtd="getListMode ? 1 : 4" v-for="item in 1" :key="item" />
          </div>
        </div>
      </infinite-loading>
    </div>

    <div class="px-4 sm:px-6 lg:px-8" v-if="!products.length && getActiveFilters.length">
      <div class="mx-auto flex h-full max-w-3xl items-center justify-center space-x-6">
        <div class="space-y-6">
          <h1 class="text-ontick-carbon-900 text-2xl font-bold dark:text-gray-300">Nenhum investimento encontrado</h1>
          <p class="text-ontick-carbon-900 dark:text-gray-400">
            Não encontramos nenhum investimento que corresponde aos critérios dos filtros selecionados.
          </p>
        </div>
        <span v-html="image_filter" class="scale-75 transform"></span>
      </div>
    </div>
    <!-- <menu-mobile @favorite="expandFavorite" /> -->

    <ontick-aero :active="active_filter" @close="active_filter = false">
      <aba-filter
        v-show="active_filter"
        @close="active_filter = false"
        @show-ranking="
          (val) => {
            showRanking = val;
          }
        "
      />
    </ontick-aero>
    <ontick-aero :active="active_favorite" @close="active_favorite = false">
      <marketplace-favorite v-show="active_favorite" @details="activeDetails" @close="active_favorite = false" />
    </ontick-aero>
    <ontick-aero :active="active_details" @close="(active_details = false), (details_index = null)">
      <product-component
        v-if="active_details"
        :strategy_id="details.strategy"
        :product_id="details.product"
        :marketplace_status="details.marketplace_status"
        :active="active_details"
        :pagination="details_index"
        :index_last="products.length - 1"
        :product_listed="filtered_results.find((item) => item.product_id === details.product).product_listed"
        @close="(active_details = false), (details_index = null)"
        @pagination="GoAndComeDetails"
        @openVideoModal="
          openUpgradeModal({
            error: { modal_action: 'strategy_unavailable_for_plan' },
            strategy: { strategy_name: '', strategy_tier: '' },
          })
        "
      />
    </ontick-aero>
    <ontick-upgrade-modal-component
      v-model="upgradeModalData.active"
      :type="upgradeModalData.type"
      :productName="upgradeModalData.name"
      :productPlan="upgradeModalData.plan"
      @close="resetModalData"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { filter } from "../../../../assets/icons/isometric";
import InfiniteLoading from "vue-infinite-loading";
import PartnerHeaderComponent from "../../components/products/partner-header.component.vue";
import OntickUpgradeModalComponent from "../../../../shared/components/basic/ontick-upgrade-modal.component.vue";
import FilterIndicatorsComponent from "../../components/products/filter-indicators.component.vue";
import HeaderAnalistasComponent from "../../components/products/header-analistas.component.vue";
export default {
  components: {
    InfiniteLoading,
    Placeholder: () => import("@/app/shared/components/placeholder/placeholder-card.component.vue"),
    CardMarketplace: () => import("@/app/modules/marketplace/components/products/card/marketplace-card.component.vue"),
    MenuMobile: () => import("@/app/modules/marketplace/components/products/marketplace.menu-mobile.component.vue"),
    AbaFilter: () => import("../../components/products/marketplace-aba-filter.component"),
    HeaderRanking: () => import("../../components/products/highlights/marketplace-highlights-header.component"),
    MenuTopMarketplace: () =>
      import("@/app/modules/marketplace/components/products/marketplace-menu-top.component.vue"),
    MarketplaceFavorite: () =>
      import("@/app/modules/marketplace/components/products/favorite/marketplace-favorite-aba.component.vue"),
    DetailsProduct: () => import("@/app/modules/marketplace/pages/details/product.component.vue"),
    ProductComponent: () => import("../details/product.component.vue"),
    MarketplaceCardPortfolio: () => import("../../components/products/card/marketplace-card.portfolio.component.vue"),
    PartnerHeaderComponent,
    OntickUpgradeModalComponent,
    FilterIndicatorsComponent,
    HeaderAnalistasComponent,
  },
  data() {
    return {
      data: [],
      FilterIndicatorsComponent,
      dropdown: { height: 0, active: false },
      dropdown_favorite: { height: 0, active: false },
      details: { strategy: 0, product: 0 },
      data_favorite: [],
      active_category: false,
      active_details: false,
      active_filter: false,
      active_favorite: false,
      details_index: null,
      list_category: [],
      list_filter: [],
      limit_page: null,
      showRanking: true,
      image_filter: filter,
      filtered_results: null,
      upgradeModalData: {
        active: false,
        type: null,
        name: null,
        plan: null,
      },
      interval: null,
      key: 9999999,
    };
  },

  computed: {
    ...mapState({
      query: (state) => state.marketplace.query,
      favorite: (state) => state.marketplace.favorite,
      page: (state) => state.marketplace.page,
    }),
    ...mapGetters({
      getListMode: "marketplace/getListMode",
      getActiveFilters: "marketplace/getActiveFilters",
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
      products: "marketplace/products",
      getPartnerSearchTerm: "marketplace/getPartnerSearchTerm",
      getPartnerInfo: "marketplace/getPartnerInfo",
    }),

    componentsStrategy() {
      let components = [];

      if (this.products.some((elem) => elem.product_type == "STRATEGY")) {
        components.push("CardMarketplace");
      }
      if (this.products.some((elem) => elem.product_type == "PORTFOLIO")) {
        components.push("MarketplaceCardPortfolio");
      }
      return components;
    },

    route() {
      return this.$route;
    },
  },

  methods: {
    ...mapActions({
      getMarketplace: "marketplace/getMarketplace",
      getMarketplaceSearch: "marketplace/getMarketplaceSearch",
      getFavorite: "marketplace/getFavorite",
      resetMarketplace: "marketplace/resetMarketplace",
      clearActiveFilters: "marketplace/clearActiveFilters",
      setPartnerSearchTerm: "marketplace/setPartnerSearchTerm",
    }),

    resetModalData() {
      this.upgradeModalData = {
        ...this.upgradeModalData,
        type: null,
        name: null,
        plan: null,
      };
    },

    openUpgradeModal(val) {
      if (val.error.modal_action) {
        this.upgradeModalData.type = val.error.modal_action;
        if (
          val.error.modal_action === "extension_unavailable_for_plan" ||
          val.error.modal_action === "strategy_unavailable_for_plan"
        ) {
          if (val.error.modal_action === "strategy_unavailable_for_plan" && this.route.name === "Analistas XP") {
            this.upgradeModalData.type = "go_to_xp";
          }
          this.upgradeModalData.name = val.strategy.strategy_name;
          this.upgradeModalData.plan = val.strategy.strategy_tier;
        }
        this.upgradeModalData.active = true;
      } else {
        this.$swal("Erro", val.error.msg, "error");
      }
    },

    randomKey() {
      return Math.floor(Math.random() * 1000);
    },

    partnerSearch() {
      if (this.getPartnerSearchTerm) {
        this.filtered_results = [];
        for (let product of this.products) {
          for (let strategy of product.strategies) {
            if (
              strategy.strategy_name.toLowerCase().includes(this.getPartnerSearchTerm.toLowerCase()) ||
              strategy.strategy_symbol.toLowerCase().includes(this.getPartnerSearchTerm.toLowerCase())
            ) {
              if (!this.filtered_results.includes(product)) {
                this.filtered_results.push(product);
              }
            }
          }
        }
      } else {
        this.filtered_results = this.products;
      }
      // console.log(this.filtered_results);
      this.setPartnerSearchTerm("");
    },

    activeDetails(strategy, product, index) {
      this.active_details = true;
      this.details_index = index;
      this.details.product = product.product_id;
      this.details.strategy = strategy.strategy_id;
      this.details.marketplace_status = strategy.marketplace_status;
    },

    GoAndComeDetails(type) {
      if (this.details_index != 0 || this.details_index != this.products.length - 1) {
        this.details_index = type == "next" ? this.details_index + 1 : this.details_index - 1;
        this.details.product = this.products[this.details_index].product_id;
        this.details.strategy = this.products[this.details_index].strategies[0].strategy_id;
      }
    },

    loadedProduct($state) {
      const getData = async () => {
        const account_id = await this.getSelectedAccount.account_id;
        if (!account_id) {
          setTimeout(getData, 1000);
        }
        if (this.route.path.includes("marketplace")) {
          this.getMarketplace({
            param: this.route.params.partner_name,
            account_id: account_id,
            extension_id: this.route.params.extension_id,
            category_group:
              this.route.name === "Analistas XP" || this.route.path.includes("analistas_xp") ? "xp" : undefined,
          })
            .then(() => {
              if (this.products.length) {
                $state.loaded();
              } else {
                $state.complete();
              }
            })
            .catch((error) => {
              // console.error(error);
              if (error.data?.max_pages) this.limit_page = error.data.max_pages;
            })
            .finally(() => {});
        }
      };
      this.$nextTick(() => {
        getData();
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(newRoute, oldRoute) {
        this.resetMarketplace();
        if (newRoute.params.partner_name) {
          this.loadedProduct();
        }

        this.getFavorite();
        if (this.route.name === "Analistas XP") {
          this.$api
            .get(this.$endpoint.GET_MARKETPLACE_CATEGORIES, {
              params: {
                category_group: "xp",
              },
            })
            .then((response) => {
              this.list_category = response.data;
            })
            .catch((error) => {
              // console.log("ERROR", error);
            });
        } else {
          this.$api
            .get(this.$endpoint.GET_MARKETPLACE_CATEGORIES)
            .then((response) => {
              this.list_category = response.data;
            })
            .catch((error) => {
              // console.log("ERROR", error);
            });
        }
      },
    },
    getSelectedAccount: {
      deep: true,
      handler(val) {
        if (val.account_id && this.route.params.partner_name) {
          this.loadedProduct();
        }
      },
    },
    products: {
      immediate: true,
      handler(val) {
        this.filtered_results = val;
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.getFavorite();
      if (this.route.name === "Analistas XP") {
        this.$api
          .get(this.$endpoint.GET_MARKETPLACE_CATEGORIES, {
            params: {
              category_group: "xp",
            },
          })
          .then((response) => {
            this.list_category = response.data;
          })
          .catch((error) => {
            // console.log("ERROR", error);
          });
      } else {
        this.$api
          .get(this.$endpoint.GET_MARKETPLACE_CATEGORIES)
          .then((response) => {
            this.list_category = response.data;
          })
          .catch((error) => {
            // console.log("ERROR", error);
          });
      }
    });

    if (this.route.query.hasOwnProperty("details") && this.route.query.details != "false") {
      let { product_id, strategy_id, details } = this.route.query;

      let index = this.products.findIndex((item) => item.product_id == parseInt(product_id));

      if (index != -1) {
        this.activeDetails(parseInt(strategy_id), parseInt(product_id), index);
      } else {
        this.activeDetails(parseInt(strategy_id), parseInt(product_id), null);
      }

      // http://localhost:8080/marketplace?product_id=175&strategy_id=212&active=true
    }
  },

  beforeDestroy() {
    this.resetMarketplace();
  },
};
</script>

<style lang="scss" scoped>
@import "./marketplace.component.scss";
</style>
